import React from 'react'
import PropTypes from 'prop-types'
import Checkbox from '../elements/Checkbox'
import {
    SERVICE_ADSL,
    SERVICE_FIBRE,
    SERVICE_MOBILE,
    SERVICE_MOBILE_BROADBAND,
    SERVICE_NBN,
    SERVICE_PSTN,
    SERVICE_VOIP,
    SERVICE_WIRELESS
} from '../constants'

const Terms = {
    [SERVICE_ADSL]: 'https://files.exetel.com.au/terms/Exetel-Residential-Adsl-Broadband-and-Phone-Terms.pdf',
    [SERVICE_FIBRE]: 'https://files.exetel.com.au/terms/Exetel-Residential-Fibre-Broadband-Terms.pdf',
    [SERVICE_NBN]: 'https://files.exetel.com.au/terms/Exetel-Residential-Fibre-Broadband-Terms.pdf',
    [SERVICE_MOBILE]: 'https://files.exetel.com.au/terms/ResidentialTelstraMobileVoiceTermsConditions.pdf',
    [SERVICE_MOBILE_BROADBAND]: 'https://files.exetel.com.au/terms/EXE0049-R-Mobile%20broadband%20Terms%20FA.pdf',
    [SERVICE_WIRELESS]: 'https://files.exetel.com.au/terms/EXE0049-Resi_Home_Wireless_B_Telstra_Terms.pdf',
    [SERVICE_PSTN]: 'https://files.exetel.com.au/terms/EXE0049-R-Residential%20Phone%20Terms%20FA.pdf',
    [SERVICE_VOIP]: 'https://files.exetel.com.au/terms/EXE0049-R-VoIP%20Terms%20FA.pdf'
}

const AcceptableUse = {
    [SERVICE_ADSL]: 'https://files.exetel.com.au/terms/ExetelInternetAcceptableUsePolicy.pdf',
    [SERVICE_FIBRE]: 'https://files.exetel.com.au/terms/ExetelInternetAcceptableUsePolicy.pdf',
    [SERVICE_NBN]: 'https://files.exetel.com.au/terms/ExetelInternetAcceptableUsePolicy.pdf',
    [SERVICE_MOBILE]: 'https://files.exetel.com.au/terms/ExetelAcceptableMobileUsePolicy.pdf',
    [SERVICE_MOBILE_BROADBAND]: 'https://files.exetel.com.au/terms/ExetelAcceptableMobileUsePolicy.pdf',
    [SERVICE_WIRELESS]: 'https://files.exetel.com.au/terms/ExetelAcceptableMobileUsePolicy.pdf',
    [SERVICE_PSTN]: 'https://files.exetel.com.au/terms/Exetel%20Telephone_Acceptable_Use_Policy.pdf',
    [SERVICE_VOIP]: 'https://files.exetel.com.au/terms/Exetel%20Telephone_Acceptable_Use_Policy.pdf'
}

const TermsAndConditionsCheckbox = (props) => {
    const CustomerWaiver = () => {
        if ([SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_WIRELESS].includes(props.type)) {
            return ''
        }

        return <span>, the <a href='https://files.exetel.com.au/terms/CustomerServiceWaiver.pdf' target='_blank'>Customer Service Guarantee Waiver</a>,</span>
    }

    return (
        <Checkbox
            name='termsAndConditions'
            errors={props.errors}
            value={props.value}
            handleClick={props.handleClick}
        >
            I have read and accept the <a href={Terms[props.type]} target='_blank'>Terms &amp; Conditions</a>, the <a href={AcceptableUse[props.type]} target='_blank'>Acceptable Use Policy</a>{CustomerWaiver()} and the <a href='https://files.exetel.com.au/terms/ExetelPrivacyPolicy.pdf' target='_blank'>Privacy Policy</a> for my Exetel service.
        </Checkbox>
    )
}

TermsAndConditionsCheckbox.propTypes = {
    errors: PropTypes.object.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number]),
    handleClick: PropTypes.func.isRequired,
    type: PropTypes.oneOf([SERVICE_ADSL, SERVICE_FIBRE, SERVICE_MOBILE, SERVICE_MOBILE_BROADBAND, SERVICE_NBN, SERVICE_PSTN, SERVICE_VOIP, SERVICE_WIRELESS]).isRequired
}

export default TermsAndConditionsCheckbox



// WEBPACK FOOTER //
// ./resources/js/components/TermsAndConditionsCheckbox.js